import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { MglArtApi } from './PersonMglArtApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.WebApi.Versicherung.Mitgliedschaftanlagedaten
 * Daten für die Mitgliedschaftanlage
 * Endpoints: /api/v2/versicherungen/fahrrad/anlage, /api/haustier/anlage, /api/ps/anlage, /api/rrv/anlage, /api/us/anlage, /api/versicherungen/aksbep/anlage, /api/versicherungen/akslangzeit/anlage, /api/versicherungen/incoming/anlage, /api/versicherungen/brs/anlage, /api/versicherungen/phv/anlage, /api/versicherungen/us/anlage, /api/versicherungen/ps/anlage, /api/v2/versicherungen/rrv/anlage, /api/zuhause/hausrat/anlage, /api/zuhause/schutzbrief/anlage
 */
export class MitgliedschaftanlagedatenApi extends BaseApiModel {
	constructor(initialProperties?: Partial<MitgliedschaftanlagedatenApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected tarif: MglArtApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.MglArt
	 */
	get Tarif(): MglArtApi {
		return this.tarif;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.MglArt
	 */
	set Tarif(value: MglArtApi) {
		this.tarif = value;
	}

	protected werbeschluessel: string;
	/**
	 * Description: Werbeschlüssel der Mitgliedschaft
	 * APIL Type: string
	 */
	get Werbeschluessel(): string {
		return this.werbeschluessel;
	}

	/**
	 * Description: Werbeschlüssel der Mitgliedschaft
	 * APIL Type: string
	 */
	set Werbeschluessel(value: string) {
		this.werbeschluessel = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): MitgliedschaftanlagedatenApi {
		return AppUtils.Helper.createFromMap(dataObject, MitgliedschaftanlagedatenApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Tarif = this.tarif;
		result.Werbeschluessel = this.werbeschluessel;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}